import { useEditorStore } from '../../store/editorStore';

export default function TransformProperties({ layer }) {
  const updateLayerTransform = useEditorStore((s) => s.updateLayerTransform);
  const t = layer.transform;

  function update(field, value) {
    updateLayerTransform(layer.id, { [field]: value });
  }

  return (
    <div className="p-2">
      <p className="panel-label mb-2">Position & Size</p>
      <div className="grid grid-cols-2 gap-1.5">
        <NumField label="X %" value={t.x} onChange={(v) => update('x', v)} step={0.5} />
        <NumField label="Y %" value={t.y} onChange={(v) => update('y', v)} step={0.5} />
        <NumField label="W %" value={t.width} onChange={(v) => update('width', v)} min={1} step={0.5} />
        <NumField label="H %" value={t.height} onChange={(v) => update('height', v)} min={1} step={0.5} />
        <NumField label="Rotation" value={t.rotation} onChange={(v) => update('rotation', v)} min={-360} max={360} />
        <NumField label="Opacity" value={Math.round(t.opacity * 100)} onChange={(v) => update('opacity', v / 100)} min={0} max={100} />
      </div>
    </div>
  );
}

function NumField({ label, value, onChange, step = 1, min = -9999, max = 9999 }) {
  return (
    <div>
      <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>{label}</label>
      <input
        type="number"
        value={Math.round(value * 100) / 100}
        onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
        step={step}
        min={min}
        max={max}
        className="input-field py-1 text-xs"
      />
    </div>
  );
}
